export default "__VITE_ASSET__Dk8v2yht__"